import type { DistrictStats } from './districtStatsApi';

export type Tile = { value: string; label: string };

export const EMPTY_TILE = '\u2014';

export function previousSchoolYearLabel(now: Date): string {
  const start = now.getUTCMonth() >= 6 ? now.getUTCFullYear() - 1 : now.getUTCFullYear() - 2;
  return `${start}-${String(start + 1).slice(2)}`;
}

const count = (value: number | undefined): string => (value === undefined ? EMPTY_TILE : String(value));

export function tileRows(stats: DistrictStats, now: Date): Tile[][] {
  const exitCycle = stats.exited?.cycle ?? previousSchoolYearLabel(now);
  return [
    [
      { value: count(stats.activeMl), label: 'Active ML students' },
      { value: count(stats.monitoredMl), label: 'Monitored ML students' },
      { value: count(stats.exited?.count), label: `Exited in ${exitCycle}` },
      { value: count(stats.newcomerMl), label: 'Newcomer ML students' },
    ],
    [
      { value: count(stats.longTermMl), label: 'Long-term ML students' },
      { value: count(stats.mlWithIep), label: 'ML + IEP students' },
      { value: count(stats.benchmarksYtd), label: 'FL360 benchmarks YTD' },
      { value: count(stats.assignmentsYtd), label: 'FL360 assignments YTD' },
    ],
  ];
}
